import { sendPost } from "src/utils/sendApi";

export const invite = sendPost("v1/data/_invite");

export const fetchPendingInvitations = sendPost("v1/data/invited_users")

export const resendEmailInvitation = sendPost("v1/data/_resend_invite")

export const withdrawInvitationApi = sendPost("v1/data/_delete_invite")